import { useReducer } from "react";

import styled from "styled-components";

import { PixelPlaceholderLoader } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { NoData } from "pro-features/components/NoData/src/NoData";

import GenericWidgetSearchOverview from "../GenericWidget/GenericWidgetSearchOverview";

import CompetitorsScatter from "./components/CompetitorsScatter/CompetitorsScatter";
import ScatterFilters from "./components/ScatterFilters";
import useCompetitorScatterWidget from "./hooks/useCompetitorScatterWidget";
import { LoadingWrapper, NoDataWrapper, ScatterLayout, Hr } from "./styledComponents";
import { filterReducer, initialFilters } from "./utils/filtersReducer";

const Container = styled.div`
    min-width: 670px;
`;
const SearchCompetitorsWidget = () => {
    const [filters, dispatch] = useReducer(filterReducer, initialFilters);

    const { scatterDataItems, isLoading, metrics, config, subtitleFilters, footerButtonsConfig, switcherConfig } =
        useCompetitorScatterWidget(filters);

    return (
        <Container data-automation="SearchCompetitorsScatter">
            <GenericWidgetSearchOverview
                title={"analysis.source.search.overview.search.competitors.title"}
                tooltip={"analysis.source.search.overview.search.competitors.tooltip"}
                subtitleFilters={subtitleFilters}
                footerButtonsConfig={footerButtonsConfig}
                switcherConfig={switcherConfig}
            >
                {isLoading ? (
                    <LoadingWrapper>
                        <PixelPlaceholderLoader
                            height={380}
                            width="100%"
                        />
                    </LoadingWrapper>
                ) : (
                    <>
                        <ScatterLayout>
                            <ScatterFilters
                                filters={filters}
                                dispatch={dispatch}
                            />
                            {scatterDataItems.length === 0 ? (
                                <NoDataWrapper>
                                    <NoData
                                        title={translate("global.nodata.notavilable")}
                                        subtitle=""
                                        titleSize="14px"
                                    />
                                </NoDataWrapper>
                            ) : (
                                <CompetitorsScatter
                                    metrics={metrics}
                                    scatterDataItems={scatterDataItems}
                                    config={config}
                                />
                            )}
                        </ScatterLayout>
                        {scatterDataItems.length > 0 ? <Hr /> : null}
                    </>
                )}
            </GenericWidgetSearchOverview>
        </Container>
    );
};

export default SearchCompetitorsWidget;
